import EkskulGuru from "../../../../../components/categories/siakad/lms/data_ekskul_guru/Home";
export default function Home() {
  
  return (
    <EkskulGuru />
  );
}
